import { Protection } from "@sportal/api";

import { getCustomProtections } from "../../pages/profiles/components/webFilters/webFilters.selectors";
import { RootState } from "../root.reducer";
import { getCategories } from "../root.selectors";
import { getProfileProtection } from "../profiles/profiles.selectors";
import { getNames } from "./categories.helpers";
import { getProfileProtectionCategories } from "../protections/protections.selectors";

export const getCategoryNames = (state: RootState): string[] => {
  return getCategories(state).map(getNames);
};

export const getCategoriesBlockedByWebFilter =
  (profileId: string) =>
  (state: RootState): string[] => {
    const protection: Protection = getProfileProtection(profileId)(state);
    const categoriesByProtection: string[] =
      getProfileProtectionCategories(profileId)(state);
    const customProtections: Record<string, string[]> =
      getCustomProtections(state);

    return protection !== Protection.Custom
      ? categoriesByProtection
      : customProtections[profileId] || [];
  };
